import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const AutoConsoBarChart = props => {
    const [consoVisible, setConsoVisible] = useState(false);
    const [prodVisible, setProdVisible] = useState(false);
    const [autoConsoVisible, setAutoConsoVisible] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(props.data);
    }, [props.data]);

    const setVisible = value => {
        if (value === 'Conso') {
            setConsoVisible(!consoVisible);
        } else if (value === 'Prod') {
            setProdVisible(!prodVisible);
        } else {
            setAutoConsoVisible(!autoConsoVisible);
        }
    };

    return (
        <ResponsiveContainer key={data.length} minHeight={300} minWidth={300} width={'95%'} height={'50%'}>
            <BarChart key={data.length} data={data} margin={10}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey={'date'}
                    scale={'band'}
                    xAxisId={0}
                    type="category"
                    tickFormatter={value => {
                        return (
                            (props.filter === 'hours' && `${moment(value).format('HH')}h`) ||
                            (props.filter === 'rollingHours' && `${moment(value).format('HH')}h`) ||
                            (props.filter === 'rollingDays' && moment(value).format('D MMM')) ||
                            (props.filter === 'rollingMonths' && moment(value).format('MMM YYYY')) ||
                            (props.filter === 'rollingYears' && moment(value).format('YYYY'))
                        );
                    }}
                />
                <XAxis dataKey={'date'} scale={'band'} xAxisId={1} hide />
                <YAxis
                    tickFormatter={value => {
                        return value / 1000;
                    }}
                />
                <Tooltip
                    labelFormatter={label => {
                        return `${moment(label).format('D MMM YYYY HH')}h`;
                    }}
                    formatter={(value, name, props) => {
                        return Math.round((value * 100) / 1000) / 100;
                    }}
                    cursor={{ fill: 'transparent' }}
                />
                <Legend onClick={e => setVisible(e.value)} />
                {!props.productStats && <Bar dataKey={'wh'} unit={' kWh'} name="Conso" fill="#2196F3" xAxisId={0} hide={consoVisible} />}
                {!props.productStats && <Bar dataKey="watth" unit={' kWh'} name="Prod" fill="#4CAF50" xAxisId={0} hide={prodVisible} />}
                {props.productStats && <Bar dataKey="watth" unit={' kWh'} name="Measure" fill="#419b91" xAxisId={0} />}

                {!props.productStats && (
                    <Bar dataKey="wh_autoconsumed" unit={' kWh'} name="AutoConso" xAxisId={1} fill="#fa8816" hide={autoConsoVisible} />
                )}
            </BarChart>
        </ResponsiveContainer>
    );
};

export default AutoConsoBarChart;



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/AutoConsoBarChart.js